module.exports = __webpack_public_path__ + "static/media/tj.c8b3c494.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tj.svg
// module id = 264
// module chunks = 0